import React from 'react';
import { useSelector} from 'react-redux';
import {SkynetLogSearch} from "../../../Components/Logging/SkynetLogForm";
import {SkynetLogResults} from "../../../Components/Logging/SkynetLogResults";
import {useTranslation} from "react-i18next";
import Spinner from "../../../Components/Fundamentals/Spinner/Spinner";

export const SkynetLogContainer = ({ customer}) => {
    const { t } = useTranslation();
    const logs = useSelector(state => state.ActionLogReducer.actionLogs);
    const isLoading = useSelector(state => state.CommonReducer.dataLoading.customerActionLogs);

    return (<>
            <SkynetLogSearch customer={customer}/>
            {isLoading ? <Spinner/> :
                logs?.length > 0 ? <SkynetLogResults logs={logs}/> : <p>{t('actionlogcontainer.noentriesfound')}</p>}
        </>
    );
}